// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { CandidateMeResponse } from "../types";
import { createQueryKey } from "../utils/keys";

// ---------------------------------------------------------------
// Mutation Keys
// ---------------------------------------------------------------
export const postMagicLinkMutationKey = ["postMagicLink"] as const;
export const postPortalLoginMutationKey = ["postPortalLogin"] as const;
export const postXLoginMutationKey = ["postXLogin"] as const;
export const postProviderRedirectMutationKey = [
  "postProviderRedirect",
] as const;
export const postCandidateLogoutMutationKey = ["postCandidateLogout"] as const;
export const patchCandidateMeMutationKey = ["patchCandidateMe"] as const;

// ---------------------------------------------------------------
// Query Keys
// ---------------------------------------------------------------
export const getMagiclinkCallbackQueryKey = (params: { token: string }) =>
  createQueryKey<unknown>()(["auth", "email", "callback", params] as const);

export const getProviderCallbackQueryKey = (
  provider: "github" | "linkedin",
  params: { state: string; error?: string },
) => createQueryKey<unknown>()(["auth", provider, "callback", params] as const);

export const getCandidatesMeQueryKey = (job_opening_slug: string) =>
  createQueryKey<CandidateMeResponse>()([
    "jobopenings",
    job_opening_slug,
    "candidates",
    "me",
  ] as const);
